exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntd.cellStyle {\n  /*position: relative;*/\n}\ntd.cellStyle .cell {\n  position: fixed;\n  top: 60%;\n  margin-left: 50px;\n  /*left: 600px;*/\n}\n.el-table__footer td.cellStyle div {\n  display: none;\n}\n", ""]);

// exports
